import { useEffect, useRef } from 'react';
import { Map } from 'mapbox-gl';
import mapboxgl from 'mapbox-gl';
import { useSvgIcon } from '../utils/svgIconLoader';

interface UseRemoteNodeMarkerOptions {
  map: Map | null;
  location: { lat: number; lng: number } | null;
}

export const useRemoteNodeMarker = ({
  map,
  location,
}: UseRemoteNodeMarkerOptions) => {
  const markerRef = useRef<mapboxgl.Marker | null>(null);
  const iconUrl = useSvgIcon('remote-node-marker');

  useEffect(() => {
    if (!map || !location) {
      if (markerRef.current) {
        markerRef.current.remove();
        markerRef.current = null;
      }
      return;
    }

    const newElement = document.createElement('div');
    newElement.className = 'remote-node-marker';
    newElement.style.width = '40px';
    newElement.style.height = '40px';
    newElement.style.backgroundImage = `url("${iconUrl}")`;
    newElement.style.backgroundSize = 'contain';
    newElement.style.backgroundRepeat = 'no-repeat';
    newElement.style.backgroundPosition = 'center';
    newElement.style.cursor = 'pointer';
    newElement.style.zIndex = '1000';

    if (markerRef.current) {
      markerRef.current.remove();
    }

    markerRef.current = new mapboxgl.Marker({
      element: newElement,
      anchor: 'bottom',
    })
      .setLngLat([location.lng, location.lat])
      .addTo(map);

    return () => {
      if (markerRef.current) {
        markerRef.current.remove();
        markerRef.current = null;
      }
    };
  }, [map, location, iconUrl]);

  useEffect(() => {
    return () => {
      if (markerRef.current) {
        markerRef.current.remove();
        markerRef.current = null;
      }
    };
  }, []);
};
